var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenderSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 24.906L17.73 26.915C17.372 27.263 16.773 27.109 16.628 26.631L15.252 22.101",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1041 18.927C22.1041 18.927 19.5151 21.263 18.1871 22.462C17.7901 22.82 17.8231 23.45 18.2531 23.767L23.6311 27.74C24.1601 28.131 24.9161 27.844 25.0531 27.2L27.6941 14.753C27.8221 14.151 27.2311 13.648 26.6571 13.869L11.1421 19.853C10.6851 20.029 10.7071 20.682 11.1741 20.828L15.2511 22.1",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderSubmit);
export default __webpack_public_path__ + "static/media/tenderSubmit.2b76ad283647b606d5d67d219b1c6178.svg";
export { ForwardRef as ReactComponent };